// export {default as support} from './support'
// import support from './support'
import {registerGlobalCallback as register, compareVersion} from '../helpers/index'
import _ from "lodash"
import config from "../../../../config";

export function getAppVersion() {
    if (cache_appVersion) {
        return cache_appVersion;
    } else {
        "0.0.0";
    }
}

/*请求app获取版本号后记录app版本*/
let cache_appVersion = null
const __get__app__version = () =>
    new Promise(resolve => {
        if (cache_appVersion) {
            return resolve(cache_appVersion)
        }

        bridge.fn("getAppVersionV2", {}, res => {
            //todo 这个肯定要处理
            cache_appVersion = _.get(res, "data.appVersion", "0.0.0")
            resolve(cache_appVersion)
        })
        // 未登录情况下安卓获取app版本交互存在问题，不会回调。所以默认1秒超时，认为是最旧版本。
        setTimeout(() => resolve('0.0.0'), 1000)
    })

const bridge = {
    fn: (methodName, jsonObject, callback) => {
        const api = config.apis[methodName];
        if (config.apis[methodName] && _.get(window.webkit, `messageHandlers.${methodName}.postMessage`, null)) {
            //最低版本为空 或者最低版本有值且小于当前版本 且最高版本为空 或者小于最高版本
            if (!api.IOS || ((!api.IOS.minVersion || (api.IOS.minVersion && compareVersion(getAppVersion(), api.IOS.minVersion))) && (!api.IOS.maxVersion || (api.IOS.maxVersion && compareVersion(api.IOS.maxVersion, getAppVersion()))))) {
                //IOS不支持 0.0.0的回调 会造成回调不返回 所以把版本号的.去掉
                const callbackName = register(callback, methodName, getAppVersion() ? getAppVersion().replace(/[^0-9]/ig,"") : "")
                window.webkit.messageHandlers[methodName].postMessage({
                    params: jsonObject ? JSON.stringify(jsonObject) : "{}",
                    method: callbackName
                })
            } else {
                callback && typeof callback && callback({
                    success: false,
                    errCode: -1,
                    data: methodName + "当前版本:" + getAppVersion() + "不支持当前所在APP版本"
                })
                console.warn(methodName + "当前版本:" + getAppVersion() + "不支持当前所在APP版本")
            }
        }
        else {
            callback && typeof callback && callback({success: false, errCode: -1, data: "方法" + methodName + "不存在"})
            console.warn("方法" + methodName + "不存在")
        }

    },
}

__get__app__version();
// support.connect(bridge)

export default bridge;
